export const StudentStatus = {
    ACTIVE: 'ACTIVE',
    ACADEMIC_LEAVE: 'ACADEMIC_LEAVE',
    EXPELLED: 'EXPELLED',
    GRADUATED: 'GRADUATED',
};
/** Значення в порядку оголошення в схемі. */
export const STUDENT_STATUS_VALUES = ['ACTIVE', 'ACADEMIC_LEAVE', 'EXPELLED', 'GRADUATED'];
export const STUDENT_STATUS_LABELS = {
    ACTIVE: 'Навчається',
    ACADEMIC_LEAVE: 'Академічна відпустка',
    EXPELLED: 'Відраховано',
    GRADUATED: 'Випускник',
};
export const STUDENT_STATUS_TONES = {
    ACTIVE: 'success',
    ACADEMIC_LEAVE: 'warning',
    EXPELLED: 'danger',
    GRADUATED: 'neutral',
};
//# sourceMappingURL=student-status.js.map